import { useContext } from 'react'

import { AuthContext } from '@/shared/auth/AuthContext'
import type { User } from '@/shared/auth/types'

export function useAuth() {
  const context = useContext(AuthContext)
  if (!context) throw new Error('useAuth precisa estar dentro de <AuthProvider>')
  return context
}

export const displayName = (user: User | null) =>
  user?.first_name || user?.username || user?.email || ''
